import { Nemesis } from '../../../../aer-types/types'

export const nemeses: Nemesis[] = [
  {
    expansion: 'TA',
    name: 'Tułacz',
    id: 'TheWanderer',
    health: 40,
    difficulty: 5,
    expeditionRating: 3,
    additionalInfo: '',
  },
]
